import React from 'react'
import { Spinner } from 'grommet'

export default function Loading({ color }) {
  return <Spinner size="small" color={color || 'brand'} />
}
